import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { AuthProvider } from './auth/AuthContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import { installGlobalErrorHandlers } from './lib/errorReporter'
import './index.css'

// Funnel uncaught window errors + unhandled promise rejections into the
// structured error reporter (FE1). The ErrorBoundary below catches React
// render throws; these handlers catch everything outside React's tree.
installGlobalErrorHandlers()

// One QueryClient per app instance. Defaults err on the side of fewer
// background fetches because the console is a low-traffic admin UI
// where stale-while-revalidate is more annoying than helpful — the
// pages most users care about (settings, allowlist) are write-heavy
// and benefit from explicit invalidation on mutation success.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      retry: 0,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
